import { createStore } from "redux";
import rootReducer from "./reducers";

// This will make the dev tools extension useful after install: https://github.com/reduxjs/redux-devtools
export default createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
